import { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import Modal from "react-modal";

const InventoryClosingList = (props) => {
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: getClosingStock } = useHttp();

  const getStock = () => {
    getClosingStock(
      {
        url: `/api/dailyClosingViewList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          // console.log(res);
          setData(res.stockDailyClosing);
          setAllData(res.stockDailyClosing);
        }
      }
    );
  };

  useEffect(() => {
    getStock();
  }, []);

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.stockDailyClosingDate?.includes(filetrtext) ||
        item?.employeeName?.includes(filetrtext) ||
        item?.warehouseName?.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const { sendRequest: getDetailView } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    console.log(data);

    const warehouseId = data && data.warehouseId;

    getDetailView(
      {
        url: `/api/stockDailyClosing/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehouseId=${warehouseId}`,
      },
      (res) => {
        console.log("Detail View", res.output);
        setSelectedData(res.output);
      }
    );

    //  setSelectedData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <h4 className="card-title">Daily Closing Stock Details</h4>
        <div className="card-tools text-right">
          <button
            type="button"
            className="btn btn-tool"
            data-card-widget="remove"
            onClick={() => setIsModalOpen(false)}
          >
            <i className="fas fa-times" />
          </button>
          <hr />
        </div>
        {selectedData && (
          <div>
            <div className="row">
              <p className="col-md-6">
                Stock Closing Date:{" "}
                {selectedData[0] && selectedData[0].stockDailyClosingDate}
              </p>
              <p className="col-md-6">
                Employee Name :{" "}
                {selectedData[0] && selectedData[0].employeeName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Warehouse Name :{" "}
                {selectedData[0] && selectedData[0].warehouseName}
              </p>
            </div>

            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th> Item Id </th>
                    <th>Product Name</th>
                    <th> Product Item Sub Type </th>
                    <th>Product Item Type </th>
                    <th>Item Quantity </th>
                    <th>Unit</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedData &&
                    selectedData.map((itm, i) => {
                      return (
                        <tr key={i} className="cursor-pointer">
                          <td>{i + 1}</td>
                          <td> {itm.itemId} </td>

                          <td> {itm.productName} </td>

                          <td>{itm.productSubTypeName}</td>

                          <td> {itm.productTypeName} </td>
                          <td> {itm.stockQuantity} </td>
                          <td> {itm.unitAbbreviation} </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Daily Closing Stock</label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                sId(serviceId);
                props.update(false);
              }}
            >
              Add Closing Stock
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Employee Name</th>
                          <th>Warehouse</th>

                          {canView === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.stockDailyClosingDate}</td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.warehouseName}</td>
                                {/* 
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(itm)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td> */}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default InventoryClosingList;
